import { render } from "./ResponsiveLayout.vue?vue&type=template&id=031e4865&scoped=true"
import script from "./ResponsiveLayout.vue?vue&type=script&lang=js"
export * from "./ResponsiveLayout.vue?vue&type=script&lang=js"

import "./ResponsiveLayout.vue?vue&type=style&index=0&id=031e4865&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031e4865"]])

export default __exports__